import axios from 'axios'
import { toast } from '../components/Toast'

const client = axios.create({
  baseURL: '/api',
})

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

client.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config

    // 401 → 토큰 갱신 시도
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true
      const refresh = localStorage.getItem('refresh_token')
      if (refresh) {
        try {
          const { data } = await axios.post('/api/auth/refresh', { refresh_token: refresh })
          localStorage.setItem('access_token', data.access_token)
          localStorage.setItem('refresh_token', data.refresh_token)
          original.headers.Authorization = `Bearer ${data.access_token}`
          return client(original)
        } catch {
          localStorage.clear()
          window.location.href = '/login'
          return Promise.reject(error)
        }
      } else {
        localStorage.clear()
        window.location.href = '/login'
        return Promise.reject(error)
      }
    }

    // 네트워크 오류
    if (!error.response) {
      toast('서버에 연결할 수 없습니다. 네트워크를 확인해주세요.', 'error')
      return Promise.reject(error)
    }

    // 5xx 서버 오류
    if (error.response.status >= 500) {
      toast('서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.', 'error')
    }

    return Promise.reject(error)
  }
)

export default client
